import { VideoSummaryFragment } from "@graphql/generated/graphql";
import Link from "next/link";
import Image from "next/image";

interface IShortsCardProps {
  short: VideoSummaryFragment;
}

const ShortsCard: React.FC<IShortsCardProps> = ({
  short: { id, imageUrl, title },
}) => {
  return (
    <div className="py-4 hover:cursor-pointer">
      <Link href={`/shorts/${id}`} passHref>
        <div className="relative flex flex-col items-start">
          <div className="aspect-w-9 aspect-h-16 relative w-full">
            <Image
              className="rounded-lg"
              src={imageUrl}
              alt={title}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <p className="mt-4 overflow-ellipsis font-poppins text-xs font-bold text-text-darkest line-clamp-2 hover:text-text-dark md:text-sm">
            {title}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default ShortsCard;
